import _ from 'lodash';
import {openDB, deleteDB, wrap, unwrap} from 'idb';

/*
 * This is application specific Middleware and will process only GET_ALL_TASKS action
 * Responsibilities:
 * If app is offline, update the api url to remove the pagination in querystring and include only category of allTasks(2)
 * If app is online, then get tasklist from idb. If empty create with default values
 */
const tasklist = (config) => (store) => (next) => (action) => {
	const __NAME = 'Task List Middleware',
		GET_ALL_TASKS = 'GET_ALL_TASKS',
		API_ERRORS = 'API_ERRORS';

	// Middleware only for action type GET_ALL_TASKS
	if (
		!(
			action.type === GET_ALL_TASKS ||
			action.type === 'GET_TASK_DOCUMENT_RELATE'
		)
	) {
		return next(action);
	}

	let method, url, data, headers, auth;

	if (action.meta && action.meta.api) {
		url = action.meta.api.url;
		method = action.meta.api.method;
		headers = action.meta.api.headers;
		data = action.meta.api.data;
	}

	if (action.meta.auth) {
		auth = action.meta.auth;
	}

	const ONLINE_DB = 'ONLINE_DB',
		OFFLINE_DB = 'OFFLINE_DB';

	const dbPromise = openDB('canvas-idb', 1, {
		upgrade(db) {
			db.createObjectStore(ONLINE_DB);
			db.createObjectStore(OFFLINE_DB);
		}
	});

	const idbKeyval = {
		async get(key) {
			return (await dbPromise).get(ONLINE_DB, key);
		},
		async set(key, val) {
			return (await dbPromise).put(ONLINE_DB, val, key);
		},
		async setOffline(key, val) {
			return (await dbPromise).put(OFFLINE_DB, val, key);
		},
		async delete(key) {
			return (await dbPromise).delete(ONLINE_DB, key);
		},
		async clear() {
			return (await dbPromise).clear(ONLINE_DB);
		},
		async keys() {
			return (await dbPromise).getAllKeys(ONLINE_DB);
		}
	};

	if (!config) {
		const configMsg = `
		Config unavailable.
		The AD package requires config to get the authorization token for the api call.`;
		console.log(configMsg);
	}

	let updateTasksinIDB = function(tasks) {
		if (!tasks) {
			//current api call response ===> action.response
			//existing data from indexedDB ===> tasks
			let taskData = _.cloneDeep(action.response);
			taskData.totalCount = 0;
			taskData.availablePages = 1;
			taskData.taskGroups = [
				{
					id: null,
					groupName: '',
					tasks: []
				}
			];
			idbKeyval.set(action.meta.api.url, taskData);
		}

		//TODO: Remove tasklist_backup record from idb

		action.response.urlToRetrieve = action.meta.api.url;
		action.meta.api.url = 'tasklist_backup';
		return next(action);
	};

	if (action.type === 'GET_TASK_DOCUMENT_RELATE') {
		if (!action.isOnline) {			
			let engagementIdFragment = action.meta.api.url.toLowerCase().indexOf('/engagements/')> -1 ? 
				action.meta.api.url.toLowerCase().split('/engagements/')[1] :
				action.meta.api.url.toLowerCase().split('engagementid=')[1];
			let engagementId = engagementIdFragment.split('/')[0].split('&')[0];
				
			action.meta.api.url = engagementId + '_' + 'offlineEvidences';
		}
		return next(action);
	}

	if (action.type === GET_ALL_TASKS) {
		if (!action.isOnline) {
			if (url.split('categoryId=2').length > 1) {
				action.meta.api.url =
					url.split('?')[0] + '?categoryId=2&subCategoryId=1';
			}
			return next(action);
		}
		action.meta.api.url = url.split('?')[0] + '?categoryId=2&subCategoryId=1';

		//retrieve tasks collection from indexedDB
		idbKeyval
			.get(action.meta.api.url)
			.then(updateTasksinIDB)
			.catch((er) => {
				console.info('[GET]: offline - Error in indexedDB call', er);
				action.error = er;
				action.response = {};
				return next({type: API_ERRORS, er});
			});
	}
};

export default tasklist;
